export const languageMap = {
  'en': 'en-US',
  'en-us': 'en-US',
  'en-gb': 'en-US',
  'tr': 'tr-TR',
  'tr-tr': 'tr-TR'
};

export const availableLanguages = [
  {
    value: 'en-US',
    label: 'English (US)'
  },
  {
    value: 'tr-TR',
    label: 'Türkçe'
  }
];

export const rtlLanguages = [];
